// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoSquareURL from './raw.noindex/logo-square.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoSquareComponent from './raw.noindex/logo-square.svg?react';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoRectURL from './raw.noindex/logo-rect.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoRectComponent from './raw.noindex/logo-rect.svg?react';
import LottieEmptyStateJSON from './raw.noindex/lottie-empty-state.json';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import BackgroundDefaultURL from './raw.noindex/background-default.jpg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import BackgroundTrainerURL from './raw.noindex/background-trainer.jpg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import BackgroundAlacarteURL from './raw.noindex/background-alacarte.jpg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import BackgroundWorkURL from './raw.noindex/background-work.jpg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import BackgroundTechURL from './raw.noindex/background-tech.jpg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import FlagItalyComponent from './raw.noindex/flag-italy.svg?react';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import FlagUSComponent from './raw.noindex/flag-us.svg?react';

export const assets = {
  LogoSquare: {
    url: LogoSquareURL,
    Component: LogoSquareComponent,
  },
  LogoRect: {
    url: LogoRectURL,
    Component: LogoRectComponent,
  },
  LottieEmptyState: {
    json: LottieEmptyStateJSON,
  },
  BackgroundDefault: {
    url: BackgroundDefaultURL,
  },
  BackgroundTrainer: {
    url: BackgroundTrainerURL,
  },
  BackgroundAlacarte: {
    url: BackgroundAlacarteURL,
  },
  BackgroundWork: {
    url: BackgroundWorkURL,
  },
  BackgroundTech: {
    url: BackgroundTechURL,
  },
  FlagItaly: {
    Component: FlagItalyComponent,
  },
  FlagUS: {
    Component: FlagUSComponent,
  },
};
